import { Component, HostListener } from '@angular/core';
import { ViewportScroller } from '@angular/common';
@Component({
    standalone: false,
    selector: 'app-tap-to-top',
    templateUrl: './tap-to-top.component.html'
})
export class TapToTopComponent  {  
  public show: boolean = false;
  constructor(private readonly viewScroller: ViewportScroller) { }
  @HostListener("window:scroll", [])
  onWindowScroll() {
    let number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  	if (number > 600) { 
  	  this.show = true;
  	} else {
  	  this.show = false;
  	}
  }
  tapToTop() {
  	this.viewScroller.scrollToPosition([0, 0]);
  }
}